module.exports = __webpack_public_path__ + "static/media/account-cowboy-hat.b3074d20.svg";